import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class AddressTypeModel {

    private serviceName = '/addressType';

    async GetCorporateTradeInStats(entityTypeId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetCorporateTradeInStats?entityTypeId=${entityTypeId}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetCorporateTradeInExport(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetCorporateTradeInExport`, data).catch((err: Error) => {
            throw err?.message;
        })
    }
}

export default new AddressTypeModel();